import { envConfig } from '@src/utils/envConfig';
import { SessionExpiredModal, useWLOrgConfigContext } from '@talos/kyoko';

export function WLSessionExpiredModal() {
  const { config } = useWLOrgConfigContext();
  const shouldHideSessionExpiredModal = config.hideSessionExpiredModal === true;

  return (
    <SessionExpiredModal
      sessionCookieName={envConfig.VITE_SESSION_COOKIE}
      sessionCheckRequestPath="/users"
      disabled={shouldHideSessionExpiredModal}
    />
  );
}
